import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { FiEdit, FiEye, FiTrash2 } from "react-icons/fi";
import { IoSearchOutline } from "react-icons/io5";
import Grid, { GridHeader, GridRow } from "../../components/Grid/Grid";
import ShareService from "../../Services/ShareService";
import WebService from "../../Services/WebService";
import UserDelete from "../../components/UserDelete/UserDelete";
import Loader from "../../components/Loader/Loader";
import HelperService from "../../Services/HelperService";
import { HiCheck } from "react-icons/hi2";
import { HiBan } from "react-icons/hi";
import { toast } from "react-toastify";
import "./ExaminerPayment.scss";
import { useForm } from "react-hook-form";

const AdminExaminerPayments: React.FC = () => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [ShowLoader, setShowLoader] = useState(false);
  const [FilterObj, setFilterObj] = useState<any>({});
  const [Count, setCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [request, setRequest] = useState<any>("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [activeTab, setActiveTab] = useState("PENDING");
  const [acceptModal, setAcceptModal] = useState(false);
  const item = useParams();
  const [showPanel, setShowPanel] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState<any>(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [accepttId, setAcceptId] = useState<any>("");
  const [showAcceptLoader, setShowAcceptLoader] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showRejectLoader, setShowRejectLoader] = useState(false);
  const [paymentReferenceId, setPaymentReferenceId] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },     
  } = useForm();

  useEffect(() => {
    const prevFilter: any = ShareService.getMapValue(
      "listing-adminpayment-filter",
    );
    if (prevFilter) {
      setFilterObj(prevFilter);
      setSearchKeyword(prevFilter.keyword || "");
      setActiveTab(prevFilter.status || "PENDING");
      getlist(
        prevFilter.offset ? prevFilter.offset + 1 : 1,
        prevFilter.keyword,
        prevFilter.order_by,
        prevFilter.sort_by,
        prevFilter.status || "PENDING",
      );
    } else {
      getlist(1);
    }
  }, []);

  const tabs = [
    { label: "Pending", value: "PENDING" },
    { label: "Paid", value: "PAID" },
    { label: "Rejected", value: "REJECTED" },
  ];
  const handleTabClick = (status: string) => {
    setActiveTab(status);
    const obj = {
      offset: 0,
      keyword: "",
      status,
    };
    setFilterObj(obj);
    ShareService.setMapValue("listing-adminpayment-filter", obj);
    getlist(1, "", "", "", status);
  };
  const onchange = (currentPage: number, searchText?: string) => {
    let obj: any = { ...FilterObj };
    obj.offset = currentPage ? currentPage - 1 : 0;
    obj.keyword = searchText !== undefined ? searchText : searchKeyword;
    ShareService.setMapValue("listing-adminpayment-filter", obj);
    setFilterObj(obj);
    getlist(currentPage, obj.keyword, activeTab);
  };

  const onSort = (sortKey: string, order: string, sort_by: any) => {
    const obj: any = { ...FilterObj };
    const orderBy = order ? "asc" : "desc";
    obj.sort_by = sort_by;
    obj.order_by = orderBy;
    obj.status = activeTab;
    ShareService.setMapValue("listing-adminpayment-filter", obj);
    setFilterObj(obj);
    getlist(1, obj.keyword, orderBy, sort_by, activeTab);
  };

  const getlist = (
    page: number,
    searchText?: string,
    order_by?: string,
    sort_by?: string,
    status?: string,
  ) => {
    setShowLoader(true);

    const obj: any = { ...FilterObj };
    obj.offset = page ? page - 1 : 0;
    obj.keyword = searchText ?? "";
    if (status) obj.status = status;
    if (order_by) obj.order_by = order_by;
    if (sort_by) obj.sort_by = sort_by;

    setFilterObj(obj);
    ShareService.setMapValue("listing-adminpayment-filter", obj);

    const queryParams = new URLSearchParams({
      keyword: obj.keyword || "",
      sort_by: obj.sort_by || "",
      order_by: obj.order_by || "",
      offset: obj.offset.toString(),
      limit: "10",
      status: obj.status || "PENDING",
    }).toString();

    WebService.getAPI({ action: `/examiner/payments/list?${queryParams}` })
      .then((res: any) => {
        setShowLoader(false);
        setCount(res.count ?? 0);
        const builtRows: GridRow[] = (res.list || []).map(
          (pageItem: any, i: number) => {
            return {
              data: [
                { value: obj.offset === 0 ? i + 1 : 10 * obj.offset + i + 1 },
                // { value: pageItem.candidate_name },
                { value: pageItem.examiner_name },
                { value: pageItem.payment_reference_id },
                { value: pageItem.total_amount },
                // { value: `${pageItem.start_time} - ${pageItem.end_time}` },
                //  { value: pageItem.type },
                {
                  value:
                    pageItem.type?.toUpperCase() === "DEMO"
                      ? "Practice"
                      : HelperService.getTitleCase(pageItem.type),
                },
                { value: pageItem.exam_session_type },

                {
                  value:
                    pageItem.payment_status === "PAID" ? (
                      <span className="badge bg-success">Paid</span>
                    ) : pageItem.payment_status === "PENDING" ? (
                      <span className="badge bg-warning text-dark">
                        Pending
                      </span>
                    ) : (
                      <span className="badge bg-danger">Failed</span>
                    ),
                },
                {
                  value: actionList(pageItem),
                },
              ],
            } as GridRow;
          },
        );

        setRows(builtRows);
      })
      .catch((err: any) => {
        console.error("getlist error:", err);
        setShowLoader(false);
      });
  };

  const onSave = (data: any) => {
    setShowRejectLoader(true);
    WebService.postAPI({
      action: `/user/inactive_status/${data.uuid}`,
      body: null,
    })
      .then((res: any) => {
        toast.success(res.message || "User set to INACTIVE");
        setShowRejectModal(false);
        closeRejectModal();
        getlist(
          FilterObj?.offset + 1 || 1,
          searchKeyword,
          FilterObj?.order_by,
          FilterObj?.sort_by,
        );
      })
      .catch((err) => {
        console.error("inactiveStatus error:", err);
        toast.error(err?.message || "Failed to set inactive");
        setShowLoader(false);
      });
  };
  const closeRejectModal = () => {
    setShowRejectModal(false);
    getlist(
      FilterObj?.offset + 1 || 1,
      searchKeyword,
      FilterObj?.order_by,
      FilterObj?.sort_by,
    );
  };
  const activeStatus = (uuid: any) => {
    setShowAcceptLoader(true);
    WebService.postAPI({
      action: `/examiner/payments/accept/${uuid}`,
      body: {
        payment_reference_id: paymentReferenceId || null, // optional
      },
    })
      .then((res: any) => {
        toast.success(res.message || "User set to ACTIVE");
        setAcceptModal(false);
        closePanel();
        setPaymentReferenceId("");
        setShowAcceptLoader(false);
        getlist(
          FilterObj?.offset + 1 || 1,
          searchKeyword,
          FilterObj?.order_by,
          FilterObj?.sort_by,
        );
      })
      .catch((err) => {
        console.error("activeStatus error:", err);
        toast.error(err?.message || "Failed to set active");
        setShowLoader(false);
      });
  };

  const handleDelete = (id: any) => {
    setShowModal(true);
    setRequest(id);
  };
  const openDetailsPanel = async (uuid: string) => {
    setShowPanel(true);
    setLoadingDetails(true);

    try {
      const res: any = await WebService.getAPI({
        action: `/examiner/payment/details/${uuid}`,
      });

      setPaymentDetails(res);
    } catch (err) {
      toast.error("Failed to load payment details");
    }

    setLoadingDetails(false);
  };
  const handleAccept = (details: any) => {
    console.log("details", details.payment.uuid);

    setAcceptId(details.payment.uuid);
    setAcceptModal(true);
  };
  const closeAcceptModal = () => {
    setAcceptModal(false);
  };

  const closePanel = () => {
    setShowPanel(false);
    setPaymentDetails(null);
  };
  const actionList = (data: any) => {
    return (
      <div className="action-btns text-left">
        {/* Details */}
        <a
          onClick={() => openDetailsPanel(data.uuid)}
          className="text-dark p-1 me-1"
          title="View"
        >
          <FiEye size={18} />
        </a>
      </div>
    );
  };

  const headers: GridHeader[] = [
    { title: "Sr No", class: "text-center" },
    // {
    //   title: "Candidate Name",
    //   class: "text-center",
    //   isSorting: true,
    //   sortingKey: "user_id",
    // },
    {
      title: "Examiner Name",
      class: "text-center",
      isSorting: true,
      sortingKey: "ep.examiner_id",
    },

    {
      title: "Payment reference ID",
      class: "text-center",
      isSorting: true,
      sortingKey: "ep.payment_reference_id",
    },
    {
      title: "Amount",
      class: "text-center",
      isSorting: true,
      sortingKey: "ep.amount",
    },
    {
      title: "Type",
      class: "text-center",
      isSorting: true,
      sortingKey: "es.type",
    },
    {
      title: "Exam Session Type",
      class: "text-center",
      isSorting: true,
      sortingKey: "es.exam_session_type",
    },
    {
      title: "Status",
      class: "text-center",

      sortingKey: "payment_status",
    },
    {
      title: "Action",
      class: "text-center",
    },
  ];

  const [gridHeader] = useState<GridHeader[]>(headers);

  return (
    <div className="dashboard-content">
      <Row className="mb-3 align-items-center justify-content-between">
        <Col lg={7}>
          <h1 className="font-20 font-bold mb-0">Manage Examiner Payments</h1>
        </Col>
        <Col lg={3} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <InputGroup.Text>
              <IoSearchOutline size={18} />
            </InputGroup.Text>
            <Form.Control
              id="listing-lesson-search"
              placeholder="Search..."
              value={searchKeyword}
              onChange={(e: any) => setSearchKeyword(e.target.value)}
              onKeyUp={(e: any) => getlist(1, e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
      <div className="examiner-tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            className={`examiner-tab-btn ${
              activeTab === tab.value ? "active" : ""
            }`}
            onClick={() => handleTabClick(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <Loader show={ShowLoader} />

      <Row>
        <Col lg={12} sm={12} className="mt-2">
          <div
            className="p-2 card"
            style={{ marginBottom: 70, height: "100vh", overflow: "scroll" }}
          >
            {/* {permissions.can_read ? ( */}
            <Grid
              headers={gridHeader}
              rows={rows}
              count={Count}
              ShowLoader={ShowLoader}
              hoverRow={true}
              perPageItem={10}
              currentPage={FilterObj ? FilterObj?.offset + 1 : 1}
              errorMessage={"No data Found"}
              onPageChange={onchange}
              onSort={onSort}
            />
            {/* ) : (
              <div className="text-center p-5">
                <h5 className="text-danger">Access Denied</h5>
              </div>
            )} */}
          </div>
        </Col>
      </Row>

      {showModal && (
        <UserDelete
          id={request}
          title="Are you sure you want to delete!"
          showModal={showModal}
          onCloseModel={() => {
            setShowModal(false);
            getlist(1, searchKeyword);
          }}
        />
      )}
      {/* 🔥 Background blur overlay */}
      {showPanel && <div className="blur-overlay" onClick={closePanel} />}

      {/* 🔥 Right slide-in panel */}
      {showPanel && (
        <div className="right-panel">
          <div className="panel-header">
            <h4>Payment Details</h4>
            <button className="close-btn" onClick={closePanel}>
              ×
            </button>
          </div>

          {loadingDetails ? (
            <p className="text-center mt-4">Loading...</p>
          ) : paymentDetails ? (
            <div className="panel-content">
              <div className="payment-box">
                <p>
                  <strong>Reference:</strong>{" "}
                  {paymentDetails.payment.payment_reference_id}
                </p>
                <p>
                  <strong>Total Amount:</strong>
                  {paymentDetails.payment.total_amount}
                </p>
                <p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {HelperService.getStatusTags(paymentDetails.payment.status)}
                  </p>
                </p>
              </div>

              <h5 className="mt-4 mb-2">Candidates</h5>

              {paymentDetails.details.map((item: any) => (
                <div key={item.detail_id} className="candidate-box">
                  <p>
                    <strong>Name:</strong> {item.candidate_name}
                  </p>
                  <p>
                    <strong>Email:</strong> {item.candidate_email}
                  </p>
                  <p>
                    <strong>Amount:</strong> ₹{item.candidate_amount}
                  </p>
                  <p>
                    <strong>Session Time:</strong> {item.session_time}
                  </p>
                </div>
              ))}

              {/* ⭐ Buttons at VERY BOTTOM after all candidates */}
              {paymentDetails.payment.status === "PENDING" && (
                <div className="decision-buttons mt-4">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleAccept(paymentDetails)}
                  >
                    Accept
                  </button>
                  <button className="btn btn-danger btn-sm ms-2">Reject</button>
                </div>
              )}
            </div>
          ) : null}
        </div>
      )}

      <Modal show={acceptModal} onHide={() => setAcceptModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure you want to accept?</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* <div className="font-16 text-center pt-2 mb-3">
      Are you sure you want to accept?
    </div> */}

          {/* 🔥 Payment Reference Input */}
          <Form.Group>
            <Form.Label>Payment Reference ID (Optional)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter payment reference ID"
              value={paymentReferenceId}
              onChange={(e) => setPaymentReferenceId(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="justify-content-center pt-2 border-top-0">
          <Button
            variant="outline-primary me-3"
            onClick={closeAcceptModal}
            disabled={showAcceptLoader}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={() => activeStatus(accepttId)}
            disabled={showAcceptLoader}
          >
            {showAcceptLoader && <Spinner size="sm" className="me-2" />}
            Accept
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        centered
      >
        <form onSubmit={handleSubmit(onSave)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation?</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* <div className="font-16 text-center pt-2">
                  Are you sure you want to reject?
                </div> */}

            <div className="form-group mb-3">
              <label>Please enter reason</label>
              <input
                type="action_comment"
                className="form-control"
                placeholder="Enter new email"
                {...register("action_comment", {
                  required: "Reason is required",
                })}
              />
              {errors.action_comment && (
                <small className="text-danger d-block mt-1">
                  {String(errors.action_comment.message)}
                </small>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer className="justify-content-center pt-2 border-top-0">
            <Button
              variant="outline-primary me-3"
              onClick={closeRejectModal}
              disabled={showRejectLoader}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={showRejectLoader}>
              {showRejectLoader && <Spinner size="sm" className="me-2" />}{" "}
              Reject
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default AdminExaminerPayments;
